import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'local',
	pure: true
})
export class LocalPipe implements PipeTransform {

	transform(value: any, handler: (value: any,  ...args: any[]) => any, thisContext: any, ...args: any[]) {
		const h = handler.bind(thisContext);
		return h(value, args);
	}

}
